
"use client";

import Image from "next/image";
import { SectionWrapper } from "@/components/section-wrapper";
import Link from "next/link";
import { cn } from "@/lib/utils";

const team = [
    {
        name: "Verónica San Frutos",
        description: "Verónica San Frutos, especializada en comunicación sanitaria, desarrolla desde 'ybuenaletra' proyectos y contenidos que conectan con los pacientes y refuerzan el compromiso de las marcas con el bienestar. Su experiencia profesional se une a su vivencia personal, ya que es celíaca desde niña, aportando una perspectiva única y empática al proyecto.",
        image: "/img/vero9bn.webp",
        hint: "professional woman",
        logo: "/img/logo-ybuenaletra-cuadrado.png",
        logoAlt: "Logo cuadrado de la empresa ybuenaletra",
        logoUrl: "https://www.ybuenaletra.com/",
        objectFit: "cover",
        objectPosition: "center 10%",
        className: "scale-[1.15] group-hover:scale-[1.25]"
    },
    {
        name: "Ángel Ramírez",
        description: "Ángel Ramírez es periodista, creador del reconocido Diabetes Experience Day, el mayor evento europeo con protagonismo de las personas con diabetes y CEO de la agencia de contenidos P360. También fundó Canal Diabetes, el primer canal online en castellano dedicado a esta enfermedad.",
        image: "/img/image36.webp",
        hint: "professional man",
        logo: "/img/logo-P360-3.png",
        logoAlt: "Logo de la agencia P360",
        logoUrl: "https://www.p360.es/",
        objectFit: "cover",
        objectPosition: "center 38%",
        className: "group-hover:scale-105"
    }
];

export function OrganizersClientWrapper() {
    return (
        <SectionWrapper id="who-we-are" className="bg-card text-card-foreground">
            <div className="mx-auto max-w-4xl text-center mb-8">
                <p className="text-primary font-semibold">Sin Gluten Experience Day</p>
                <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl font-headline text-card-foreground">
                    ORGANIZADORES
                </h1>
            </div>
            <div className="grid gap-12 md:grid-cols-2 items-stretch">
                {team.map((member, index) => (
                    <div key={index} className="flex flex-col items-center text-center gap-6 p-6 bg-background text-foreground rounded-lg shadow-lg">
                        <div className="relative w-full h-80 rounded-lg overflow-hidden group">
                            <Image
                                key={member.image}
                                src={member.image}
                                alt={`Retrato profesional de ${member.name}, organizador/a de Sin Gluten Experience Day.`}
                                fill={true}
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                style={{
                                    objectFit: (member as any).objectFit,
                                    objectPosition: (member as any).objectPosition,
                                    filter: "grayscale(100%) sepia(15%) brightness(1.05) contrast(1.1)"
                                }}
                                className={cn("rounded-lg transition-transform duration-300", member.className)}
                                data-ai-hint={member.hint}
                                priority={index === 0}
                            />
                            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
                        </div>
                        <div className="flex flex-col flex-1">
                            <div className="my-6 flex justify-center items-center h-20">
                                <Link href={member.logoUrl} target="_blank" rel="noopener noreferrer" className="relative w-48 h-full">
                                    <Image
                                        src={member.logo}
                                        alt={member.logoAlt}
                                        fill
                                        sizes="192px"
                                        className="object-contain"
                                    />
                                </Link>
                            </div>
                            <p className="text-foreground/80 md:text-lg/relaxed text-justify">{member.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
}
